import React from 'react';
import { useSelector } from 'react-redux';
import { useAppDispatch } from '~/hooks/useAppDispatch';
import useTranslate from '~/hooks/useTranslate';
import { RootState } from '~/store';
import { onChangeInputEvent, onFocusSelectEvent } from '~/types/types';
import { Button, Stack } from '@qred/components-library';
import { useForm, SubmitHandler, FormProvider } from 'react-hook-form';
import { pushToGtmLoanAction } from '~/store/actions/gtmActions';
import AMLFields from '../AMLFields/AMLFields';
import { ILoanOfferApplicant } from '~/interfaces/loanOffer';
import { updateApplicant } from '~/store/slices/loanOffer.slice';

interface ApplicantProps {
  applicant: ILoanOfferApplicant;
  onBlur: (name: onChangeInputEvent | onFocusSelectEvent | string) => void;
}

const Applicant = ({ applicant, onBlur }: ApplicantProps) => {
  const translate = useTranslate();
  const dispatch = useAppDispatch();

  const {
    matchedMedia: { mobile },
  } = useSelector((state: RootState) => state);

  const formMethods = useForm<ILoanOfferApplicant>({
    defaultValues: applicant,
    mode: 'onTouched',
  });

  const {
    handleSubmit,
    formState: { isSubmitting, isSubmitSuccessful },
  } = formMethods;

  const saveApplicant: SubmitHandler<ILoanOfferApplicant> = (formData) => {
    dispatch(updateApplicant(formData));

    dispatch(
      pushToGtmLoanAction({
        actionName: 'edit_applicant_save_button_pressed',
      })
    );
  };

  return (
    <FormProvider {...formMethods}>
      <form onSubmit={handleSubmit(saveApplicant)}>
        <Stack>
          <AMLFields trackFieldChange={onBlur} />
          <Button
            variant="secondary"
            data-cy="offer_save_signer_button"
            fullWidth={mobile}
            size="md"
            type="submit"
            disabled={isSubmitting || isSubmitSuccessful}
          >
            {translate('Save')}
          </Button>
        </Stack>
      </form>
    </FormProvider>
  );
};

export default Applicant;
